query DateCalcWeek7DayTotals(
  $endDate: Date!
  $rate: BigFloat!
  $startDate: Date!
) {
  dateCalcWeek7DayTotals(
    endDate: $endDate
    rate: $rate
    startDate: $startDate
  ) {
    dayRate
    dayTotal
    endDate
    extendedTotal
    fullPeriods
    partialPeriodDays
    periodNo
    periodRate
    periodTotal
    startDate
  }
}
